/* OTTR - the burger's menu is a bottom sheet, not a dropdown.
 *
 * ONE NUMBER DECIDES EVERYTHING HERE: 1040px, which is where
 * ottr-proto-1.css swaps the desktop nav buttons for the burger:
 *
 *     @media (max-width: 1040px){ .burger{display:block} .nav{display:none} }
 *
 * The burger IS the mode switch, so every rule in this file and in
 * ottr-navmobile.css keys off the same width. Before that, the sheet
 * stopped at 749 while the burger ran to 1040, which left a 300px band -
 * every tablet - with a hamburger that opened the 343px-wide DESKTOP
 * mega-dropdown. Three header behaviours where there should be two, and
 * the middle one the worst of both. If that number ever moves in
 * proto-1, move it here and in the stylesheet together.
 *
 * This file does only the structure CSS cannot:
 *   1. MOVING THE SHEET TO <body>. .drop lives inside .hdr, which has
 *      z-index 60 and so makes a stacking context. A child cannot escape
 *      its parent's context whatever z-index it carries, so the sheet at
 *      63 painted UNDER a scrim at 62 and the menu came out dimmed. At
 *      body level the numbers mean what they say. It goes back into
 *      .barwrap above 1040, where the mega-dropdown is positioned
 *      against the bar. NOT DONE IN THE THEME EDITOR - see 6.
 *   2. a wrapper per <ul>, so it can animate to its natural height. The
 *      0fr -> 1fr trick needs ONE grid item, and a <ul> puts every <li>
 *      in a row of its own.
 *   3. a real <button> per heading, for the keyboard and the reader.
 *   4. .drop-bar, lifting the foot and the socials out of the scrolling
 *      area so they can be pinned.
 *   5. the scrim, which needs a click handler, and a close button, which
 *      a sheet needs because the only other ways out are a tap on a
 *      sliver of dimmed page or a second trip to the burger.
 *   6. THE CLICK GUARD, and the editor. Both are consequences of 1.
 *
 * Opening is still ottr-proto.js's job: it toggles .open on #mainmenu and
 * menu-open on the body, and finds the menu by id, so moving the element
 * does not disturb it.
 */
(function () {
  'use strict';
  if (window.__ottrNavMobile) return;
  window.__ottrNavMobile = true;

  /* Must match ottr-navmobile.css and proto-1's burger query. */
  var BURGER = '(max-width: 1040px)';
  var EDIT = !!(window.Shopify && window.Shopify.designMode);
  var uid = 0;

  function small() { return window.matchMedia(BURGER).matches; }

  if (EDIT && document.body) document.body.classList.add('ottr-editing');

  /* Addressed by what it should be next to, not by a placeholder node.
     A comment marker was tried first and it silently rotted: a view
     transition or a section reload replaces the header markup and
     orphans the marker, after which the menu could never go home and
     the desktop dropdown positioned itself against the viewport
     instead of the bar. Asking for .barwrap each time cannot rot, and
     both branches are idempotent.

     IN THE THEME EDITOR THE MENU STAYS WHERE THE LIQUID PUT IT. The
     editor maps a click in the preview to the section that CONTAINS the
     element clicked, and draws its selection outline around that
     section's box. Lift the menu out to <body> and half the header is no
     longer inside the header section, so clicking it selects nothing.
     The cost is that the sheet is back inside .hdr's stacking context in
     the editor - answered by dropping the scrim below it there, in
     ottr-navmobile.css section 6, rather than by leaving the menu
     unclickable to the person editing it. */
  function place() {
    if (EDIT) return;
    var drop = document.getElementById('mainmenu');
    if (!drop) return;
    if (small()) {
      if (drop.parentElement !== document.body) document.body.appendChild(drop);
    } else {
      var host = document.querySelector('.hdr .barwrap');
      if (host && drop.parentElement !== host) host.appendChild(drop);
    }
  }

  function build() {
    var drop = document.getElementById('mainmenu');
    if (!drop) return;

    if (EDIT) document.body.classList.add('ottr-editing');

    /* THE CLICK GUARD. ottr-proto.js closes the menu on any click that is
       not inside .hdr:

         if (drop.classList.contains('open') && !e.target.closest('.hdr'))
           closeMenu();

       which was right while the menu was a dropdown inside the header.
       The sheet is on <body>, so EVERY tap inside it - opening a section,
       reading a heading, missing a link - read as a tap outside the
       header and shut the whole sheet. That is the "clicking another
       segment closes the header" bug, and it made the accordion useless:
       the section did open, for the one frame before the sheet left.

       Stopping the click at the sheet is the smallest fix that does not
       require editing proto.js, which another chat also works in.
       stopPropagation does not touch default behaviour, so links inside
       still navigate, and the scrim - which is NOT inside the sheet -
       still closes it. */
    if (!drop.dataset.ottrStop) {
      drop.dataset.ottrStop = '1';
      drop.addEventListener('click', function (e) { e.stopPropagation(); });
    }

    drop.querySelectorAll('.drop-col').forEach(function (col) {
      if (col.hasAttribute('data-acc')) return;
      var head = col.querySelector('h6');
      var list = col.querySelector('ul');
      if (!head || !list) return;

      col.setAttribute('data-acc', '');
      uid += 1;
      var id = 'navacc-' + uid;

      var wrap = document.createElement('div');
      wrap.className = 'drop-col__wrap';
      wrap.id = id;
      list.parentNode.insertBefore(wrap, list);
      wrap.appendChild(list);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'drop-col__btn';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', id);
      btn.innerHTML = '<span>' + head.innerHTML + '</span>';
      head.innerHTML = '';
      head.appendChild(btn);

      /* Independent, not exclusive. Opening one section does not close
         another: on a phone the whole point of the sheet is that you can
         have the map open all at once. */
      btn.addEventListener('click', function () {
        if (!small()) return;
        toggle(col, !col.classList.contains('is-open'));
      });
    });

    /* The pinned foot. Both pieces are markup siblings inside .drop-in,
       the scrolling box; moved out, they become a flex child of the
       sheet and stay put while the links scroll under them. */
    if (!drop.querySelector('.drop-bar')) {
      var foot = drop.querySelector('.drop-foot');
      var social = drop.querySelector('.drop-social');
      if (foot || social) {
        var bar = document.createElement('div');
        bar.className = 'drop-bar';
        if (foot) bar.appendChild(foot);
        if (social) bar.appendChild(social);
        drop.appendChild(bar);
      }
    }

    closeButton(drop);
    scrim();
    place();
    openFirst();
  }

  /* A sheet needs a visible way out. Without it the only exits are the
     burger you came from - now behind a scrim - and whatever sliver of
     dimmed page is left above the sheet. */
  function closeButton(drop) {
    if (drop.querySelector('.drop-x')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'drop-x';
    b.setAttribute('aria-label', 'Close menu');
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="2" stroke-linecap="round" aria-hidden="true">' +
      '<path d="M5 5l14 14M19 5L5 19"/></svg>';
    b.addEventListener('click', close);
    drop.insertBefore(b, drop.firstChild);
  }

  function scrim() {
    if (document.querySelector('.drop-scrim')) return;
    var el = document.createElement('div');
    el.className = 'drop-scrim';
    el.setAttribute('aria-hidden', 'true');
    el.addEventListener('click', close);
    document.body.appendChild(el);
  }

  function close() {
    var burger = document.querySelector('.burger[aria-expanded="true"]');
    if (burger) { burger.click(); return; }
    document.querySelectorAll('.drop.open').forEach(function (d) { d.classList.remove('open'); });
    document.body.classList.remove('menu-open');
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('menu-open')) close();
  });

  function toggle(col, on) {
    col.classList.toggle('is-open', on);
    var btn = col.querySelector('.drop-col__btn');
    if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
  }

  /* Four closed rows read as an empty menu, so the first starts open. */
  function openFirst() {
    if (!small()) return;
    var cols = document.querySelectorAll('.drop .drop-col[data-acc]');
    if (!cols.length) return;
    var any = false;
    cols.forEach(function (c) { if (c.classList.contains('is-open')) any = true; });
    if (!any) toggle(cols[0], true);
  }

  /* Crossing up to the desktop with a section collapsed would hide links
     where there is no button to get them back. */
  function sync() {
    place();
    var cols = document.querySelectorAll('.drop .drop-col[data-acc]');
    if (!small()) cols.forEach(function (c) { toggle(c, true); });
    else cols.forEach(function (c, i) { toggle(c, i === 0); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();

  var mq = window.matchMedia(BURGER);
  if (mq.addEventListener) mq.addEventListener('change', sync);
  else if (mq.addListener) mq.addListener(sync);

  /* A resize that does not cross the breakpoint still fires none of the
     above, and a section reload rebuilds the header underneath us. */
  window.addEventListener('resize', place);
  document.addEventListener('shopify:section:load', function () { build(); sync(); });
})();
